<template>
  <div class="white-container">
    <BannerConfig v-for="(banner,index) in bannerList" :key="index" save-path="banner/" :config="banner" :index="index" :limit-size="5" @updateConfig="updateConfig($event, index)" />
    <div class="flex btns" style="justify-content:center;margin-top:50px;">
      <el-button type="primary" size="samll" @click="submit">保存</el-button>
    </div>
  </div>
</template>
<script>
import BannerConfig from '@/components/BannerConfig';

export default {
  components: { BannerConfig },
  data() {
    return {
      bannerList: [],
    };
  },
  created() {
    this.getBannerList();
  },
  methods: {
    getBannerList() {
      this.$Api.mpConfiguration.getBannerList().then(res => {
        const resLength = res.length;
        for (let i = 0; i < 5 - resLength; i++) {
          res.push({
            imageUrl: '',
            linkUrl: '',
            title: '',
          });
        }
        this.bannerList = res;
      });
    },
    submit() {
      const params = this.bannerList.slice(0).filter(item => {
        return item?.imageUrl && item?.linkUrl;
      }
      );
      if (params.every(item => item.imageUrl === '')) {
        this.$message.error('banner至少填写一个');
        return false;
      }
      this.$Api.mpConfiguration.postBannerSave(params).then(res => {
        this.$message.success('保存成功');
        this.getBannerList();
      });
    },
    updateConfig(config, index) {
      this.bannerList[index] = config;
      console.info('images', this.bannerList);
    },
  },
};
</script>

<style lang="less" scoped/>
